<dashboardnav>
  
    <cradua-encroachmentstatus
    [encroachmentstatuss]="encroachmentstatuss$ | async"
    (encroachmentstatus)="onSubmitEncroachmentStatus($event)"
    (deleteEncroachmentStatusEvent)="onDeleteEncroachmentStatus($event)"
    *ngIf="(isLoading$ | async ) === false"
    >
  </cradua-encroachmentstatus>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  